
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import AuthMixin from '~/mixins/authMixin'

import { getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'UserHeader',
  mixins: [ActiveUserMixin, AuthMixin],
  methods: { getDefaultAvatar },
  computed: {
    login() {
      return this.viewer.fullName || this.viewer.firstName || this.viewer.email
    }
  }
})
